import React, { useContext } from 'react'
import SignupContext from 'modules/react/signup/SignupContext'
import FormElementError from 'modules/react/signup/FormElementError'

export default function CourseDateSelection () {

  const signupContext = useContext(SignupContext)
  const { course, setSelectedCourseDate, setFormValue } = signupContext
  const { start_dates } = course

  const selectCourseDate = (courseDateId) => {
    setSelectedCourseDate(start_dates.find((date) => {
      return date.activity_number === courseDateId
    }))

    setFormValue('course_activity_number', courseDateId)
  }

  return (
    <>
      <div className="input-group">
        <div className="input-wrap">
          <FormElementError name="course_start_id">
            <select defaultValue="none" onChange={(e) => selectCourseDate(e.target.value)}>
              <option value="none" disabled>Vælg startdato*</option>
              {start_dates.map((date) => {
                return (
                  <option key={date.id} value={date.activity_number}>{date.start_date_display}</option>
                )
              })}
            </select>
          </FormElementError>
        </div>
      </div>
    </>
  )
}